import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import {
  BulletedList,
  Button,
  Grid,
  H,
  Image,
  P,
  TickIcon,
  Wrapper,
} from '@farewill/ui'
import { BORDER_RADIUS, COLOR, GTR } from '@farewill/ui/tokens'
import { screenMax, screenMin } from '@farewill/ui/helpers/responsive'
import WrapperWithEdge from 'components/WrapperWithEdge'
import PreventOrphan from 'components/PreventOrphan'
import { data } from './data'

const StyledTickIcon = styled(TickIcon)`
  width: 24px;
  height: 24px;
  margin-right: -${GTR.S};
`

const StyledCard = styled(Wrapper)`
  border-radius: ${BORDER_RADIUS.XL};
  height: 100%;
`

const StyledGrid = styled(Grid)`
  ${screenMin.m`
    grid-gap: 0;
    grid-column-gap: ${GTR.XL};
  `}
`

const StyledCardInnerWrapper = styled(Wrapper)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const StyledBulletedList = styled(BulletedList)`
  ${screenMax.m`
    gap: 0;
    row-gap: ${GTR.S};
  `}
`

const SliceProducts = (): ReactElement => (
  <WrapperWithEdge direction="down" lightAccent padding={[0, 0, 'L']}>
    <Wrapper container>
      <H
        size="L"
        tag="h2"
        maxWidth={575}
        margin={[0, 'auto', 'L']}
        marginFromM={[0, 'auto', 'XXL']}
        centeredFromM
        decorative
      >
        {data.title}
      </H>

      <StyledGrid maxWidth={1000} margin={[0, 'auto']}>
        {data.cards.map((card) => (
          <Grid.Item key={card.title} spanFromM={6}>
            <StyledCard
              background={COLOR.WHITE}
              padding={['L', 'M']}
              paddingFromL={['XL', 'L']}
            >
              <StyledCardInnerWrapper>
                <Wrapper margin={[0, 0, 'M']}>
                  <Image path={card.image} width={250} height={160} />
                </Wrapper>
                <Wrapper>
                  <H size="M" tag="h3">
                    {card.title}
                  </H>
                  <P>{card.subtitle}</P>
                  {card.bulletedList && (
                    <StyledBulletedList
                      icon={
                        <StyledTickIcon
                          background={COLOR.WHITE}
                          color={COLOR.BLACK}
                          inline
                        />
                      }
                      padding={['S', 0, 'L']}
                    >
                      {card.bulletedList.map((item) => (
                        <BulletedList.Item key={item}>
                          <PreventOrphan>{item}</PreventOrphan>
                        </BulletedList.Item>
                      ))}
                    </StyledBulletedList>
                  )}
                </Wrapper>
                <Wrapper>
                  <Button.Primary
                    key={card.ctaLink.text}
                    type="button"
                    tag={Link}
                    to={card.ctaLink.to}
                    stretch
                  >
                    {card.ctaLink.text}
                  </Button.Primary>
                </Wrapper>
              </StyledCardInnerWrapper>
            </StyledCard>
          </Grid.Item>
        ))}
      </StyledGrid>
    </Wrapper>
  </WrapperWithEdge>
)

export default SliceProducts
